import React, { useState } from 'react';
import { Container, ThisCard, ThisCardAnal } from './styles';

import IconSelectiveActive from '~/assets/icones/IconSelectActive.svg';
import IconCliente from '~/assets/icones/IconClientesAtivo.svg';
import IconAnalista from '~/assets/icones/IconAnalistaAtivo.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  let analista = [{ id: 1, nome: 'Jorge Medeiros', aberto: true }];
  let acesso = [{ id: 1, nome: 'Jorge Medeiros', aberto: true }];

  return (
    <Container>
      {data?.map((thisData, i) => (
        <ThisCard
          className={
            linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'
          }
          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
          key={thisData?.id || i}
          id={thisData?.id || i}
          index={i}
          ativo={linhaAtiva === thisData?.id ? true : false}
        >
          <div className="card-top">
            <div className="card-top-left">
              <img class="iCliente" src={IconCliente} alt="Vazio" />
              <p className="titulo">{thisData?.nomeFantasia}</p>
            </div>
            <div className="card-top-right">
              <img src={IconSelectiveActive} alt="Vazio" />
            </div>
          </div>
          <div className="card-list">
            {analista?.map(thisAnal => (
              <ThisCardAnal
                className={
                  linhaAtiva === thisAnal?.id ? 'card-item ativo' : 'card-item'
                }
                {...{ data: thisAnal, linhaAtiva, setLinhaAtiva }}
                key={thisAnal?.id || i}
                id={thisAnal?.id || i}
                index={i}
                ativo={linhaAtiva === thisAnal?.id ? true : false}
              >
                <div className="card-a-top">
                  <div className="card-a-top-left">
                    <img class="iAnalista" src={IconAnalista} alt="Vazio" />
                    <p className="titulo-a">{thisAnal?.nome}</p>
                  </div>
                  <div className="card-a-top-right">
                    <img src={IconSelectiveActive} alt="Vazio" />
                  </div>
                </div>
                <div className="card-a-list">
                  <div className="list-a">
                    <div className="list-a-itens">
                      <p className="titulo-a-list">Acesso Servidor</p>
                      <p className="subtitulo-a-list">
                        Servidor:porta: {thisAnal?.nome}
                      </p>
                      <p className="subtitulo-a-list">
                        Environment: {thisAnal?.nome}
                      </p>
                      <p className="subtitulo-a-list">
                        Usuário: {thisAnal?.nome}
                      </p>
                      <p className="subtitulo-a-list">
                        Senha: {thisAnal?.nome}
                      </p>
                    </div>
                    <div className="list-a-itens">
                      <p className="titulo-a-list">Acesso Servidor</p>
                      <p className="subtitulo-a-list">
                        Servidor:porta: {thisAnal?.nome}
                      </p>
                      <p className="subtitulo-a-list">
                        Environment: {thisAnal?.nome}
                      </p>
                      <p className="subtitulo-a-list">
                        Usuário: {thisAnal?.nome}
                      </p>
                      <p className="subtitulo-a-list">
                        Senha: {thisAnal?.nome}
                      </p>
                    </div>
                    <div className="list-a-itens">
                      <p className="titulo-a-list">Acesso Servidor</p>
                      <p className="subtitulo-a-list">
                        Servidor:porta: {thisAnal?.nome}
                      </p>
                      <p className="subtitulo-a-list">
                        Environment: {thisAnal?.nome}
                      </p>
                      <p className="subtitulo-a-list">
                        Usuário: {thisAnal?.nome}
                      </p>
                      <p className="subtitulo-a-list">
                        Senha: {thisAnal?.nome}
                      </p>
                    </div>
                    <div className="list-a-itens">
                      <p className="titulo-a-list">Acesso Servidor</p>
                      <p className="subtitulo-a-list">
                        Servidor:porta: {thisAnal?.nome}
                      </p>
                      <p className="subtitulo-a-list">
                        Environment: {thisAnal?.nome}
                      </p>
                      <p className="subtitulo-a-list">
                        Usuário: {thisAnal?.nome}
                      </p>
                      <p className="subtitulo-a-list">
                        Senha: {thisAnal?.nome}
                      </p>
                    </div>
                  </div>
                </div>
              </ThisCardAnal>
            ))}
          </div>
        </ThisCard>
      ))}
    </Container>
  );
}

export default CustomBodyContent;
